"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _TopicMetadata = require("@insided/destination/modules/Content/TopicList/TopicMetadata");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListItemCard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItemCard, _Component);

  var _super = _createSuper(TopicListItemCard);

  function TopicListItemCard() {
    (0, _classCallCheck2.default)(this, TopicListItemCard);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicListItemCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          userTitle = _this$props.userTitle,
          contentType = _this$props.contentType,
          categoryUrl = _this$props.categoryUrl,
          categoryName = _this$props.categoryName,
          hideCategoryMetadata = _this$props.hideCategoryMetadata;
      var topicCategoryMetadataPhrase = (0, _TopicMetadata.getMetadataPhrase)(contentType);
      return (0, _preact.h)("div", {
        className: "topic-list-item-card_header"
      }, (0, _preact.h)("div", {
        className: "topic-list-item-card_user-image-container"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: user,
        extraClass: "avatar",
        showRank: true
      })), (0, _preact.h)("div", {
        className: "topic-list-item-card_header_metadata"
      }, (0, _preact.h)("div", {
        className: "topic-list-item-card_header_user-info"
      }, (0, _preact.h)(_UserName.default, {
        user: user,
        extraClass: "username"
      }), userTitle && (0, _preact.h)("span", {
        className: "user-title text--meta"
      }, userTitle)), !hideCategoryMetadata && !!categoryName && (0, _preact.h)("div", {
        className: "topic-list-item-card_topic-location-container"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(categoryUrl),
        "data-track-type": "click",
        className: "topic-list-item-card_topic-location-link"
      }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: topicCategoryMetadataPhrase
      })), (0, _preact.h)("span", {
        className: "topic-list-item-card_topic-name"
      }, categoryName)))));
    }
  }]);
  return TopicListItemCard;
}(_preact.Component);

var _default = TopicListItemCard;
exports.default = _default;